import * as types from './types';

const initialState = {
  loading: false,
  error: null,
  list: null,
  totalItems: 0,
  item: null,
  updating: false,
  mensajeErrorUpdating: null,
  updateSuccess: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case types.GET_LIST_CONFIG_START:
      return {
        ...state,
        error: null,
        loading: true,
        updateSuccess: false,
      };
    case types.GET_CONFIG_START:
    case types.CREATE_CONFIG_START:
    case types.UPDATE_CONFIG_START:
      return {
        ...state,
        mensajeErrorUpdating: null,
        updateSuccess: false,
        updating: true,
      };
    case types.GET_LIST_CONFIG_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case types.GET_CONFIG_ERROR:
    case types.CREATE_CONFIG_ERROR:
    case types.UPDATE_CONFIG_ERROR:
      return {
        ...state,
        updating: false,
        updateSuccess: false,
        mensajeErrorUpdating: payload,
      };
    case types.GET_LIST_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        list: payload.data,
        totalItems: parseInt(payload.headers['x-total-count'], 10),
      };
    case types.GET_CONFIG_SUCCESS:
    case types.CREATE_CONFIG_SUCCESS:
    case types.UPDATE_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        updating: false,
        updateSuccess: true,
        item: payload.data,
      };
    case types.RESET:
      return {
        ...initialState,
      };
    case types.RESET_CONFIG:
      return {
        ...state,
        item: initialState.item,
      };
    default:
      return state;
  }
};
